import { createSelector } from 'reselect';
import { StoreState } from 'store/types';
import { TifdState } from './types';

const selectTifd = (state: StoreState): TifdState => state.tifd;

export const getTifdLoading = createSelector(
  selectTifd,
  (tifd): TifdState['loading'] => tifd.loading
);

export const getTifdError = createSelector(
  selectTifd,
  (tifd): TifdState['error'] => tifd.error
);

export const getTifdReport = createSelector(
  selectTifd,
  (tifd): TifdState['report'] => tifd.report
);

export const getTifdContext = createSelector(
  selectTifd,
  (tifd): TifdState['context'] => tifd.context
);

export const getTifdWorkbookLoading = createSelector(
  selectTifd,
  (tifd): TifdState['workbookLoading'] => tifd.workbookLoading
);
